import jApi from './jApi';

export default {
  getListThirdPartyConnection(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/plugin/connection/list', { params })
      .then(res => res);
  },

  detailThirdPartyConnection(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/plugin/connection/detail', { params })
      .then(res => res.data);
  },

  createThirdPartyConnection(params) {
    const api = jApi.generateApi();
    return api.post('/nocode/plugin/connection/create', params)
      .then(res => res.data);
  },

  updateThirdPartyConnection(params) {
    const api = jApi.generateApi();
    return api.post('/nocode/plugin/connection/update', params)
      .then(res => res.data);
  },

  deleteThirdPartyConnection(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/plugin/connection/delete', { params })
      .then(res => res.data);
  },

  getThirdPartyPlugin(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/plugin/list', { params })
      .then(res => res.data);
  },

  getListDirectoryFtp(params) {
    const api = jApi.generateApi();
    return api.post('/nocode/ftp/list', params)
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiThirdParty.js